export default __webpack_public_path__ + "static/Poppins-Regular.35d26b78.ttf";